import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ThemeType = 'default' | 'blue' | 'purple' | 'green'

interface ThemeState {
  theme: ThemeType
}

const initialState: ThemeState = {
  theme: (localStorage.getItem('theme') as ThemeType) || 'default',
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeType>) => {
      state.theme = action.payload
      localStorage.setItem('theme', action.payload)
    },
  },
})

export const { setTheme } = themeSlice.actions
export default themeSlice.reducer
